import { Button } from '@cian/ui-kit/button';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './CookiesNotification.css';

interface ICookiesNotificationProps {
  noResize?: boolean;
  onAgreementView(): void;
  onAccept(): void;
}

export const CookiesNotification: React.FC<ICookiesNotificationProps> = ({ noResize, onAgreementView, onAccept }) => {
  return (
    <div {...mergeStyles(styles['container'], noResize && styles['desktop-only'], !noResize && styles['adaptive'])}>
      <div className={styles['description']}>
        Мы используем файлы cookie.{' '}
        <a href="#" className={styles['agreement']} onClick={onAgreementView}>
          Соглашение об использовании
        </a>
      </div>
      <div className={styles['button']}>
        <Button onClick={onAccept} theme="fill_white_primary">
          Принять
        </Button>
      </div>
    </div>
  );
};
